module.exports.run = function(options) {
    /* When the user is deactivated or his/her role is deleted manually, this'll ensure 
    assignedTo and assignedToGiven is set to make sure the record is assigned to the respective user */
    var record = options.record;
    var approvers = options.approvers;
    if (!record.get('assignedTo') && !!record.get('assignedToApproverGroupId')) {
        var assignedToApproverGroupId = record.get('assignedToApproverGroupId');
        var approversForAssignment = approvers.findWhere({ approverGroupId: assignedToApproverGroupId, approval: ''});
            if (approversForAssignment.get('upn')) {
                record.set({
                    'assignedTo': approversForAssignment.get('upn'),
                    'assignedToGivenName': approversForAssignment.get('givenName')
                })
            }

    }
}


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordAssignedTo.js